import { TableStateFilterEvent } from '@purespectrum1/ui/table';
import { Constants } from '../../dashboard-constants';

export interface SearchFlags {
  surveyTitle: boolean;
  billing: boolean;
  pm: boolean;
  bpm: boolean;
  crm: boolean;
}

export class FiltersFlagMapper {
  constructor(private readonly _filters: TableStateFilterEvent[] = []) {}

  public readonlyFlags(isMaximumFilterApplied: boolean = false): SearchFlags {
    // Logic: if we've not applied the search filter widget & maximum filter limit is hit, then we'll make readonly those widgets.
    return {
      surveyTitle: !this._surveyTitle() && isMaximumFilterApplied,
      billing: !this._billing() && isMaximumFilterApplied,
      pm: !this._pm() && isMaximumFilterApplied,
      bpm: !this._bpm() && isMaximumFilterApplied,
      crm: !this._crm() && isMaximumFilterApplied,
    };
  }

  private _isAppliedFilter(field = ''): boolean {
    return this._filters.findIndex((f) => f.field === field) !== -1;
  }

  private _crm(): boolean {
    return this._isAppliedFilter(Constants.SURVEY_LISTING_TABLE_HEADERS.CRM_ID);
  }

  private _pm(): boolean {
    return this._isAppliedFilter(
      Constants.SURVEY_LISTING_TABLE_HEADERS.OPERATOR_PROJECT_MANAGER
    );
  }

  private _bpm(): boolean {
    return this._isAppliedFilter(
      Constants.SURVEY_LISTING_TABLE_HEADERS.BUYER_PROJECT_MANAGER
    );
  }

  private _billing(): boolean {
    return this._isAppliedFilter(
      Constants.SURVEY_LISTING_TABLE_HEADERS.BILLING_NUMBER
    );
  }

  private _surveyTitle(): boolean {
    return this._isAppliedFilter(
      Constants.SURVEY_LISTING_TABLE_HEADERS.SURVEY_TITLE
    );
  }
}
